import { CreatorApplicationPage } from './CreatorApplicationPage';

export const creatorApplicationRouter = {
  '/@/creator_application': CreatorApplicationPage, // TODO: path 를 적어주세요.
};
